import { SPACING_1, SPACING_2_5, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const Styling = styled.div`
  //@todo web/body/reg
  display: grid;
  gap: ${SPACING_2_5};
  color: #181646; //@todo: use color token
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  
  ul,
  ol {
    margin: 0;
    padding-left: ${SPACING_3};

    li + li {
      margin-top: ${SPACING_1};
    }
  }

  strong {
    font-weight: 600;
  }
`;

const Wysiwyg = ({ htmlContent }: { htmlContent: string | TrustedHTML | null | undefined }) => (
  <Styling dangerouslySetInnerHTML={{ __html: htmlContent ?? '' }} />
);

export default Wysiwyg;
